const selectIsAppBootstrapReady = (state) => state.application.isBoostrapReady;
const selectShowFooter = (state) => state.application.showFooter;

export {selectIsAppBootstrapReady, selectShowFooter};
